// An unavailable check is neither a detected risk nor evidence that it is clear.
export const isRiskUnavailable = (risk) => {
  if (!risk || typeof risk.detected !== 'boolean') return true
  const status = String(risk.status || '').trim().toLowerCase()
  const details = String(risk.details || '').trim()
  return ['unknown', 'unavailable', 'error', 'pending', 'not available'].includes(status)
    || /^(api error:|error:|api key not configured)/i.test(details)
}

export const flightPathUnavailable = (dd) => isRiskUnavailable({
  detected: dd?.flight_path_detected,
  status: dd?.flight_path_status,
  details: dd?.flight_path_details,
})

export const flightPathDetected = (dd) => flightPathUnavailable(dd)
  ? null
  : typeof dd?.flight_path_detected === 'boolean' ? dd.flight_path_detected : null

export const hazardValues = (dd) => [
  dd?.flood_detected, dd?.bushfire_detected, dd?.heritage_detected, flightPathDetected(dd),
]

export const detectedRiskLabels = (dd) => {
  const labels = ['flood overlay', 'bushfire zone', 'heritage listing', 'flight-path exposure']
  return hazardValues(dd).flatMap((value, index) => value === true ? [labels[index]] : [])
}
